/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcColumnSort
 * @restrict A
 * @scope
 * @param {string} wcColumnSort The parameter holds the column sort values
 * @param {string} wcColumnSortDefault The parameter holds the default column sort values
 * @param {string} specialChars The string value holds the special characters
 * @param {string} columnIndex The variable holds the column index value
 * @description
 * The wcColumnSort directive adds column sort option to jquery datatable, this directive holds methods that are
 * related to column sort operation.
 */



angular.module('WcResponsiveTableModule').directive('wcColumnSort', [ '$timeout', function ($timeout) {
    return {
        restrict: 'A',
		require: ['wcColumnSort', '^wcResponsiveTable'],
		scope: {},
		bindToController: {
            wcColumnSort: '@',
            wcColumnSortDefault: '@',
            specialChars: '@',
            columnIndex: '@'
        },
        controllerAs: 'columnSortController',
        controller: ['$scope', '$element', function ($scope, $element) {
            var responsiveTableController = $element.parent().controller('wcResponsiveTable');

            this.tableScope = responsiveTableController.WcTableScopeService.getTableScope();
            this.collectionLength = responsiveTableController.WcTableCollectionService.getCollectionLength();
            this.resultsPerPage = responsiveTableController.WcTablePaginationService.getPaginationDefaults().resultsPerPage;
			this.sortReverse = false;

            this.sortCollection = function () {
				responsiveTableController.WcTableCollectionService.sortEnabled = true;
                //induce a delay to limit the FOUC
                $timeout(angular.bind(this, function () {
                    var collection = responsiveTableController.WcTableCollectionService.getCollection();

					var sortOn = function (arr, prop, reverse, specialChars) {
                        reverse = reverse ? 1 : -1;

                        if (!specialChars) {
                            return arr.sort(function (a, b) {
                                if (_.get(a, prop) < _.get(b, prop)) {
                                    return 1 * reverse;
                                } else if (_.get(a, prop) > _.get(b, prop)) {
                                    return -1 * reverse;
                                } else {
                                    return 0;
                                }
                            });
                        } else {
                            return arr.sort(function (a, b) {
                                return reverse === 1 ? _.get(b, prop).localeCompare(_.get(a, prop)) : _.get(a, prop).localeCompare(_.get(b, prop));
                            });
                        }
					};

					responsiveTableController.previousSortColumn = responsiveTableController.activeSortColumn;
					responsiveTableController.activeSortColumn = this.columnIndex;

					responsiveTableController.WcTableCollectionService.setCollection(sortOn(collection, this.wcColumnSort, this.sortReverse, this.specialChars), responsiveTableController.WcTableCollectionService.sortEnabled, responsiveTableController.WcTableCollectionService.filterEnabled);
                    this.tableScope.$broadcast('table.sort.complete', this.wcColumnSort, this.sortReverse);

					this.sortReverse = this.sortReverse ? false : true;
				}), 30);
            };

            if (this.wcColumnSortDefault) {
                if (this.wcColumnSortDefault == 'desc') {
					this.sortReverse = true;
                }
				this.sortCollection();
            }
            else {
				// $timeout(angular.bind(this, function(){
				// 	this.tableScope.renderTable();
				// }), 30);
				//this.tableScope.$broadcast('table.sort.complete', this.wcColumnSort, this.sortReverse);
            }
        }],
        link: function (scope, element, attrs, controllers) {
			//jshint unused:true
			var columnSortController = controllers[0];
			var responsiveTableController = controllers[1];

            element.addClass('wc-table-column-sort-heading');

            //if(scope.$parent.ngModel) {
            //include listener for when the sorted column changes
			responsiveTableController.WcTableScopeService.getTableScope().$on('table.sort.complete', function (event, column, reverse) {
                var thSpan = element.find('span[class~=glyphicon-sort]');
                var columnClass = element.attr('class').match(/wc-table-column-\d+/)[0];
                //var columnSelector = '.wc-table-column-' + scope.columnIndex;
                if (column === columnSortController.wcColumnSort) {
                    thSpan.toggleClass('glyphicon-sort', false);
                    if (!reverse) {
                        thSpan.toggleClass('glyphicon-sort-by-alphabet', true);
                        thSpan.toggleClass('glyphicon-sort-by-alphabet-alt', false);
                    }
                    else {
                        thSpan.toggleClass('glyphicon-sort-by-alphabet-alt', true);
                        thSpan.toggleClass('glyphicon-sort-by-alphabet', false);
                    }
					$('#' + responsiveTableController.id + ' .' + columnClass).addClass('wc-table-column-highlight');
                    //element.addClass('sorted');
                }
                else {
                    thSpan.toggleClass('glyphicon-sort', true);
                    thSpan.toggleClass('glyphicon-sort-by-alphabet glyphicon-sort-by-alphabet-alt', false);
					$('#' + responsiveTableController.id + ' .' + columnClass).removeClass('wc-table-column-highlight');
					//element.removeClass('sorted');
					columnSortController.sortReverse = false;
                }
            });

			responsiveTableController.WcTableScopeService.getTableScope().$on('table.render.complete', function (event) {
                var columnClass = element.attr('class').match(/wc-table-column-\d+/)[0];
                if (element.hasClass('wc-table-column-highlight')) {
					$('#' + responsiveTableController.id + ' .' + columnClass).addClass('wc-table-column-highlight');
                }
                else {
					$('#' + responsiveTableController.id + ' .' + columnClass).removeClass('wc-table-column-highlight');
                }
            });

			$timeout(function () {

			var clickableElem = element.find('.header-text, .header-icons');

            $(clickableElem).on('click', function () {
				var collectionLength = columnSortController.collectionLength;
                var showLoadingIndicator = false;

                if (columnSortController.resultsPerPage <= 25) {
                    if (collectionLength >= 100000) {
                        showLoadingIndicator = true;
                    }
                } else if (columnSortController.resultsPerPage <= 75) {
                    if (collectionLength >= 10000) {
                        showLoadingIndicator = true;
                    }
                }
                else {
                    if (collectionLength >= 1000) {
                        showLoadingIndicator = true;
                    }
                }

                if (showLoadingIndicator) {
					columnSortController.tableScope.tableIsLoading();
                }

				columnSortController.sortCollection();
            });

            }, 0);
            //glyphicon-sort-by-alphabet
            //glyphicon-sort-by-alphabet-alt
            if (element[0].children.length) {
                $timeout(function () {
                    element.find('.header-text-wrapper').append('<span class="header-icons pull-right"><span class="glyphicon glyphicon-sort"></span></span>');
                }, 0);
                // element.find('input, select').first().before('<span class="glyphicon glyphicon-sort"></span>');
                // element.find('label').after('<span class="glyphicon glyphicon-sort"></span>');

            }
            else {
                element.append('<span class="glyphicon glyphicon-sort"></span>');
            }
            //}
        }
    };
}]);
